import * as React from "react";
import type { SVGProps } from "react";
const SvgDAppsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="DApps_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M633.387 130.133a85.333 85.333 0 0 1 120.704 0L889.813 265.9a85.333 85.333 0 0 1 0 120.661L754.091 522.325a85.333 85.333 0 0 1-120.704 0L497.62 386.56a85.333 85.333 0 0 1 0-120.661l135.766-135.766zM829.483 326.23 693.76 190.464 557.995 326.229 693.76 461.995l135.765-135.766zM47.829 133.163h362.667V382.42a113.45 113.45 0 0 1-113.45 113.451H47.871V133.205zm85.334 85.333v192h163.882a28.117 28.117 0 0 0 28.16-28.075V218.453h-192zM47.829 570.837h249.216A113.45 113.45 0 0 1 410.54 684.288v249.216H47.872V570.837zm85.334 85.334v192h192V684.288a28.117 28.117 0 0 0-28.118-28.117h-163.84zm465.792 0a28.117 28.117 0 0 0-28.16 28.117v163.883h192v-192h-163.84zM485.46 684.288a113.45 113.45 0 0 1 113.494-113.45h249.173v362.666H485.461V684.288z"
    />
  </svg>
);
export default SvgDAppsIcon;
